module.exports = __webpack_public_path__ + "img/IMG_2670.e482eed2.jpg";